import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Separator from '../components/Separator';
import FeaturedSolutions, { FeaturedItem } from '../components/FeaturedSolutions';
import tabletInfoGenesis from '../assets/products/tablet-info-genesis.png';
import kioskFoodOrder from '../assets/products/kiosk-food-order.png';
import appOndemandFood from '../assets/products/app-ondemand-food.png';
import appQrQuickpay from '../assets/products/app-qr-quickpay.png';
import digitalMenu from '../assets/products/digital-menu.png';

const CafePage = () => {
  const navigate = useNavigate();

  return (
    <div className="page cafePage">
      <Header />
      <div className="page-header">On Site Dining</div>

      <div className="text-wrapper">
        <div className="top">
          <div className="topic-header">Cafe</div>
          <Separator />
        </div>
        <div className="std-text">
          {"Agilysys InfoGenesis POS provides diners with convenient self-service ordering and quick payment options.\n\nThe result is fast, accurate and on-time food delivery to keep service moving."}
        </div>
      </div>

      <FeaturedSolutions>
        <FeaturedItem
          label="InfoGenesis"
          imgSrc={tabletInfoGenesis}
          onClick={() => navigate('/solutions/info-genesis')}
        />
        <FeaturedItem
          label="IG Kiosk"
          imgSrc={kioskFoodOrder}
          onClick={() => navigate('/solutions/ig-kiosk')}
        />
        <FeaturedItem
          label="IG OnDemand"
          imgSrc={appOndemandFood}
          onClick={() => navigate('/solutions/ig-on-demand')}
        />
        <FeaturedItem
          label="IG Quick Pay"
          imgSrc={appQrQuickpay}
          onClick={() => navigate('/solutions/ig-quick-pay')}
        />
        <FeaturedItem
          label="IG Digital Menu Board"
          imgSrc={digitalMenu}
          onClick={() => navigate('/solutions/digital-menu')}
        />
      </FeaturedSolutions>
    </div>
  );
};

export default CafePage;
